/**
 * WorkflowConfigTab - the workbench. Hosts the States section and
 * the Actions section side by side. Shows a persistent banner that
 * edits apply to in-flight instances on the next transition (per the
 * engine's live-edit trade-off).
 */

import { Info } from 'lucide-react'

import type { WorkflowDefinitionAdmin } from '@/admin/hooks/use-workflow-definitions'

import { StatesSection } from './states-section'
import { ActionsSection } from './actions-section'

interface WorkflowConfigTabProps {
  workflow: WorkflowDefinitionAdmin
}

export function WorkflowConfigTab({ workflow }: WorkflowConfigTabProps) {
  const version = workflow.current_version

  if (!version) {
    return (
      <div className="rounded-[6px] border-[0.5px] border-[var(--rule)] bg-[var(--bg-subtle)] px-3 py-4 text-center text-[12px] text-[var(--ink-3)]">
        This workflow has no current version yet.
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-start gap-2 rounded-[6px] border-[0.5px] border-[var(--scope-blue-border)] bg-[var(--scope-blue-bg)] px-3 py-2 text-[11px] text-[var(--ink-2)]">
        <Info size={13} className="mt-[2px] text-[var(--status-info)]" />
        <p>
          Editing the current version. In-flight instances pick up changes
          on their next transition. Use seed commands for a clean restart.
        </p>
      </div>

      <StatesSection workflow={workflow} version={version} />
      <ActionsSection workflow={workflow} version={version} />
    </div>
  )
}
